var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58887 5.6687C4.58887 5.36811 4.81224 5.11969 5.10205 5.08037L5.18262 5.07495L15.9634 5.07495C16.2913 5.07495 16.5571 5.34078 16.5571 5.6687C16.5571 5.96929 16.3337 6.21771 16.0439 6.25703L15.9634 6.26245L5.18262 6.26245C4.8547 6.26245 4.58887 5.99662 4.58887 5.6687Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3018 2.8613C12.0694 2.62997 12.0686 2.25403 12.2999 2.02162C12.5102 1.81034 12.84 1.79041 13.0729 1.96234L13.1396 2.01968L16.3828 5.24792C16.5947 5.45891 16.614 5.79003 16.4406 6.02286L16.3828 6.08955L13.1396 9.31779C12.9072 9.54912 12.5312 9.54826 12.2999 9.31585C12.0896 9.10457 12.0712 8.77466 12.2442 8.54262L12.3018 8.47616L15.1217 5.66908L12.3018 2.8613Z",
    fill: "#2653F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44067 13.5287C2.44067 13.2281 2.66405 12.9797 2.95386 12.9404L3.03442 12.9349H13.8152C14.1431 12.9349 14.4089 13.2008 14.4089 13.5287C14.4089 13.8293 14.1855 14.0777 13.8957 14.117L13.8152 14.1224H3.03442C2.7065 14.1224 2.44067 13.8566 2.44067 13.5287Z",
    fill: "#5E7799"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61506 13.9494C2.40309 13.7384 2.38382 13.4073 2.55725 13.1745L2.61506 13.1078L5.85826 9.87954C6.09067 9.6482 6.46661 9.64907 6.69794 9.88148C6.90825 10.0928 6.92665 10.4227 6.75365 10.6547L6.696 10.7212L3.87521 13.5288L6.696 16.336C6.90728 16.5463 6.92721 16.8761 6.75528 17.109L6.69794 17.1757C6.48764 17.387 6.15782 17.4069 5.92498 17.235L5.85826 17.1776L2.61506 13.9494Z",
    fill: "#5E7799"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferOut);
export default __webpack_public_path__ + "static/media/transferOut.91c952f1474dc2a4630cb941d5d52bc3.svg";
export { ForwardRef as ReactComponent };